export default __webpack_public_path__ + "static/mobile-home-demolition-28768c019e2b65cfdbdd8b62694e8969.jpg";